<template>
  <footer class="app-footer">
    <v-container class="px-4 py-16" fluid>
      <v-layout wrap justify-center>
        <v-flex xs12 lg11 xl10>
          <v-layout wrap class="text-left">
            <!-- Brand Section -->
            <v-flex xs12 lg4 class="mb-10 mb-lg-0 pr-lg-8">
              <div class="footer-brand">
                <h2 class="brand-logo mb-4">KL 06 <span class="accent-dot">.</span></h2>
                <div class="footer-description">
                  <span v-html="footer.content || 'Premium selection of fresh farm produce, organic spices, and healthy plants delivered directly to your home.'"></span>
                </div>
                <div class="social-links mt-8 d-flex justify-start">
                  <a :href="footer.twitterlink" target="_blank" class="social-icon">
                    <v-icon color="white" size="20">mdi-twitter</v-icon>
                  </a>
                  <a :href="footer.fblink" target="_blank" class="social-icon mx-4">
                    <v-icon color="white" size="20">mdi-facebook</v-icon>
                  </a>
                  <a :href="footer.linkedInlink" target="_blank" class="social-icon">
                    <v-icon color="white" size="20">mdi-linkedin</v-icon>
                  </a>
                </div>
              </div>
            </v-flex>

            <!-- Quick Links -->
            <v-flex xs12 sm6 lg4 class="mb-8 mb-sm-0 pl-lg-10">
              <h3 class="footer-heading mb-6">Quick Links</h3>
              <ul class="footer-links-list">
                <li @click="$router.push('/aboutUs')">About Us</li>
                <li @click="$router.push('/ContactUs')">Contact Us</li>
                <li @click="$router.push('/privacyPolicy')">Privacy Policy</li>
                <li @click="$router.push('/cancellationPolicy')">Cancellation Policy</li>
                <li @click="$router.push('/termsandCondition')">Terms & Conditions</li>
                <li @click="$router.push('/ShippingAndDelivery')">Shipping & Delivery</li>
              </ul>
            </v-flex>

            <!-- Contact Section -->
            <v-flex xs12 sm6 lg4 class="pl-lg-10">
              <h3 class="footer-heading mb-6">Contact Info</h3>
              <div class="contact-info">
                <div class="contact-item d-flex align-start mb-4">
                  <v-icon color="#3EA56E" size="20" class="mr-3 mt-1">mdi-map-marker-outline</v-icon>
                  <span>2/434, Murickassery, Idukki,<br />Kerala, 685604</span>
                </div>
                <div class="contact-item d-flex align-center mb-4">
                  <v-icon color="#3EA56E" size="20" class="mr-3">mdi-phone-outline</v-icon>
                  <span>+91 87448 07234</span>
                </div>
                <div class="contact-item d-flex align-center mb-4">
                  <v-icon color="#3EA56E" size="20" class="mr-3">mdi-email-outline</v-icon>
                  <span>sithosh@hotmail.com</span>
                </div>
                <div class="contact-item d-flex align-center">
                  <v-icon color="#3EA56E" size="20" class="mr-3">mdi-file-document-outline</v-icon>
                  <span>GSTIN: 32AQUPT3997K1ZR</span>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Bottom Bar -->
    <div class="footer-bottom py-6">
      <v-container fluid>
        <v-layout wrap justify-center>
          <v-flex xs12 lg11 xl10 class="d-flex flex-column flex-md-row align-center justify-space-between">
            <div class="copyright-text mb-4 mb-md-0">
              © 2026 KL 06 Organic Farms. All rights reserved.
            </div>
            <div class="developer-credit">
              Designed & Developed by 
              <a href="#" class="dev-link">Leopard Tech Labs Pvt Ltd</a>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </footer>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      footer: {},
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/footer/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.footer = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.app-footer {
  background-color: #0f172a;
  color: #94a3b8;
  font-family: 'Poppins', sans-serif;
}

.brand-logo {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 32px;
  color: #ffffff;
  letter-spacing: -1px;
}

.brand-logo .accent-dot {
  color: #3EA56E;
}

.footer-description {
  font-size: 14px;
  line-height: 1.8;
  color: #94a3b8;
}

.footer-heading {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  position: relative;
  padding-bottom: 12px;
}

.footer-heading::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background-color: #3EA56E;
  border-radius: 2px;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links-list li {
  margin-bottom: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.footer-links-list li:hover {
  color: #3EA56E;
  transform: translateX(5px);
}

.contact-info {
  font-size: 14px;
  line-height: 1.6;
}

.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background: #3EA56E;
  transform: translateY(-3px);
}

.footer-bottom {
  background-color: #020617;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.copyright-text {
  font-size: 13px;
  color: #64748b;
}

.developer-credit {
  font-size: 13px;
  color: #64748b;
}

.dev-link {
  color: #3EA56E;
  text-decoration: none;
  font-weight: 600;
}

.dev-link:hover {
  text-decoration: underline;
}

@media (max-width: 960px) {
  .pl-lg-16 { padding-left: 0 !important; }
}
</style>